import { NotificationActionTypes, NotificationType } from './notificationTypes';

let _counter = 0;
const uid = () => `notif_${++_counter}_${Date.now()}`;

export const pushNotification = (
  type: NotificationType,
  message: string,
  duration = 4000,
) => ({
  type: NotificationActionTypes.PUSH,
  payload: { id: uid(), type, message, duration },
});

// Convenience helpers used throughout the app
export const notifySuccess = (message: string, duration?: number) =>
  pushNotification('success', message, duration);

export const notifyError = (message: string, duration?: number) =>
  pushNotification('error', message, duration ?? 6000);

export const notifyInfo = (message: string, duration?: number) =>
  pushNotification('info', message, duration);

export const notifyWarning = (message: string, duration?: number) =>
  pushNotification('warning', message, duration);

export const dismissNotification = (id: string) => ({
  type: NotificationActionTypes.DISMISS,
  payload: { id },
});

export const clearNotifications = () => ({
  type: NotificationActionTypes.CLEAR,
});
